<template lang='pug'>
div
    div.fullwidth
        UHFSensorAccessoriesOverview
        hr
        CalibratorAccessoriesOverview

</template>

<script>
import UHFSensorAccessoriesOverview from './UHFSensorAccessoriesOverview.vue';
import CalibratorAccessoriesOverview from './CalibratorAccessoriesOverview.vue';
export default {
    components: {
        UHFSensorAccessoriesOverview,
        CalibratorAccessoriesOverview,
    },
    meta: {
        de: {
            title: "BSS | Zubehör & Weiteres",
            description: "Zubehör für Sensoren und Kalibratoren",
        },
        en: {
            title: "BSS | Accessories & More",
            description: "Accessories for Sensors and Calibrators",
        },
    },
};
</script>